import { render } from "./switch-table-item.vue?vue&type=template&id=322c2b32&scoped=true&ts=true"
import script from "./switch-table-item.vue?vue&type=script&lang=ts"
export * from "./switch-table-item.vue?vue&type=script&lang=ts"

import "./switch-table-item.vue?vue&type=style&index=0&id=322c2b32&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322c2b32"]])

export default __exports__